import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <a href="#pricing" onClick={handleClick} className={`block w-full rounded-xl bg-brand-red px-3 py-3.5 text-center font-heading text-sm font-semibold uppercase leading-tight tracking-wide text-white shadow-[0_6px_18px_rgba(214,40,40,0.35)] transition duration-200 hover:-translate-y-0.5 hover:bg-[#B71C1C] focus:outline-none focus:ring-4 focus:ring-brand-red/40 active:translate-y-0 sm:text-base ${className}`} data-id="element-33" data-mp="2g1xyo9prfjjf">
      {children}
    </a>;
}